function loadingButton(element, loading = true) {
    let button = element.srcElement
    if (loading) {
        const originalText = element.srcElement.innerHTML
        localStorage.setItem('originalText', originalText)
        button.disabled = true
        button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...`
    } else {
        button.disabled = false
        button.innerHTML = localStorage.getItem('originalText')
        localStorage.removeItem('originalText')
    }
}

export default loadingButton
